import { useState } from "react";
import { markerImageURL } from "../../utils/ConstantsURL";

export const useMarkerImage = () => {
  const [loadingImage, setLoadingImage] = useState(false);

  const uploadMarkerImage = async (file, docId, moduleKey) => {
    try {
      setLoadingImage(true);

      const formData = new FormData();

      formData.append("docId", docId ?? "unknown");
      formData.append("moduleKey", moduleKey ?? "Audio");
      formData.append("image", file);

      const response = await fetch(markerImageURL(), {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (!response.ok || !result.ok) {
        throw new Error(
          result.message || "Error al subir la imagen del marcador"
        );
      }

      return {
        success: true,
        data: result.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.message || "Error al subir la imagen del marcador",
      };
    } finally {
      setLoadingImage(false);
    }
  };

  const deleteMarkerImage = async (url) => {
    try {
      const response = await fetch(markerImageURL(), {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url }),
      });

      const result = await response.json();

      return {
        success: response.ok && result.ok,
        message: result.message,
      };
    } catch (error) {
      return {
        success: false,
        message: error.message || "Error al eliminar la imagen del marcador",
      };
    }
  };

  return {
    uploadMarkerImage,
    deleteMarkerImage,
    loadingImage,
  };
};
